import EditJobOfferForm from './EditJobOfferForm'

const EditJobOffer = () => {
  return <EditJobOfferForm />
}

export default EditJobOffer
